"use client"

import { SOURCE_FILTER_ROW, sourceFilterPill } from "@/components/source-filter-pill"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { ChevronDown } from "@/lib/icons"

export interface OptionDropdownGroup {
  id: string
  /** The label before the colon on the button ("Order"). */
  label: string
  value: string
  /** The value that needs no highlight (the source's own default). */
  defaultValue: string
  options: { value: string; label: string }[]
}

interface SourceOptionDropdownsProps {
  groups: OptionDropdownGroup[]
  onChange: (groupId: string, value: string) => void
}

// A strip made of one dropdown per option group; a button highlights like an active pill once its choice differs from the default.
// Used by sources whose choices are sent as `sourceOptions` (see lib/booru-api.tsx), so a new source's strip is only its groups.
export function SourceOptionDropdowns({ groups, onChange }: SourceOptionDropdownsProps) {
  return (
    <div className={SOURCE_FILTER_ROW}>
      {groups.map((group) => (
        <DropdownMenu key={group.id}>
          <DropdownMenuTrigger asChild>
            <button className={`${sourceFilterPill(group.value !== group.defaultValue)} inline-flex items-center gap-1`}>
              {group.label}: {group.options.find((o) => o.value === group.value)?.label ?? group.value}
              <ChevronDown className="h-3 w-3" />
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className={`min-w-[11rem] ${group.options.length > 12 ? "max-h-[60vh] overflow-y-auto" : ""}`}>
            <DropdownMenuRadioGroup value={group.value} onValueChange={(next) => onChange(group.id, next)}>
              {group.options.map((option) => (
                <DropdownMenuRadioItem key={option.value} value={option.value}>
                  {option.label}
                </DropdownMenuRadioItem>
              ))}
            </DropdownMenuRadioGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      ))}
    </div>
  )
}
